import { DialogComponent } from '@theme/dialog';

class MissionStoryDialog extends DialogComponent {
  showDialog() {
    if (this.refs.dialog.open) return;

    // WebKit does not focus buttons on pointer clicks. Give the native dialog a return target.
    this.querySelector('.mission-product-story__button')?.focus({ preventScroll: true });
    super.showDialog();
  }
}

if (!customElements.get('mission-story-dialog')) {
  customElements.define('mission-story-dialog', MissionStoryDialog);
}
